import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';

interface bankDetailsBody {
  "partyId": string,
  "accountHolderName": string,
  "bankName": string,
  "accountNumber": string,
  "ifscCode": string
}

interface partyPrefBody {
  "preferenceTypeId": string,
  "partyId": string,
  "prefValue": string
}


export const getPartyById = createAsyncThunk(
  'party/get/id',
  async (partyid:string, {rejectWithValue}) => {
    let url = API_ENDPOINTS.getPartyById;
    url = url.replace(":partyid",partyid)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createBankDetails = createAsyncThunk(
  'party/createBank',
  async (reqBody:bankDetailsBody, {rejectWithValue}) => {
    let url = API_ENDPOINTS.createBankDetails;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateBankDetails = createAsyncThunk(
  'party/updateBank',
  async (reqBody:bankDetailsBody, {rejectWithValue}) => {
    let url = API_ENDPOINTS.updateBankDetails;
    const { axiosPut } = useCustomAxios();
    try {
      const response = await axiosPut(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPartyPref = createAsyncThunk(
  'party/create/preference',
  async (reqBody:partyPrefBody, {rejectWithValue}) => {
    let url = API_ENDPOINTS.createPartyPref;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePartyPref = createAsyncThunk(
  'party/update/preference',
  async (reqBody:partyPrefBody, {rejectWithValue}) => {
    let url = API_ENDPOINTS.updatePartyPref;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPartyPref = createAsyncThunk(
  'party/get/preference',
  async (partyId:string, {rejectWithValue}) => {
    let url = API_ENDPOINTS.getPartyPref;
    url = url.replace(":partyid",partyId)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getBankDetails = createAsyncThunk(
  'party/get/bankDetails',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.getBankDetails;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url,reqBody?reqBody:{});
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePartyDetails = createAsyncThunk(
  'party/put/partyDetails',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.updateParty;
    const { axiosPut } = useCustomAxios();
    try {
      const response = await axiosPut(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createPartyTags = createAsyncThunk(
  'party/tags',
  async (reqBody:any, {rejectWithValue}) => {
    let url = API_ENDPOINTS.createPartyTags;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url,reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deactivateTag = createAsyncThunk(
  'party/deactivate',
  async (tagId:string, {rejectWithValue}) => {
    let url = API_ENDPOINTS.deactivateTag;

    url = url.replace(":tagId", tagId);
    const { axiosPut } = useCustomAxios();
    try {
      const response = await axiosPut(url, {});
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPartyTags = createAsyncThunk(
  'party/tags/getAll',
  async () => {
    let url = API_ENDPOINTS.getPartyTags;
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      return error?.response?.data;
    }
  }
);


